export const retry = async (functionToExecute, success, delay = 200, max = 30) => {
    let safeguard = 0

    functionToExecute(safeguard)
    
    while (!success.value && safeguard < max) {
        safeguard += 1
        await new Promise(resolve => {
            setTimeout(() => {
                functionToExecute(safeguard)
                resolve(true)
            }, delay)
        })
    }

    return success.value ? true : false
}

export const timeout = (ms: number) => {
return new Promise(resolve => setTimeout(resolve, ms))
}